import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_CATEGORIES_APP_ROOT = `${BASE_ADMIN_V2_PATH}/categories`;

export const ADMIN_CATEGORIES_APP_PATHS = {
  CATEGORIES_LIST: `${ADMIN_CATEGORIES_APP_ROOT}`,
};
